/* ONNI Set-Preisdarstellung (Paavo 19.07.2026)
   - rotes Sale-Badge auf Set-Karten = Ersparnis ggue. Einzelkauf (Basiszustand ohne Code;
     discount.js aktualisiert den Wert, sobald ein VIP-Code aktiv ist)
   - oeffnet/schliesst das Preisinfo-Modal ("Errechnung Deiner Ersparnis") */
(function () {
  function initBadges() {
    document.querySelectorAll('[data-onni-single-total]').forEach(function (pc) {
      var card = pc.closest('product-card');
      if (!card || card.querySelector('.onni-sale-badge')) return;
      var total = parseInt(pc.getAttribute('data-onni-single-total'), 10);
      var price = parseInt(pc.getAttribute('data-onni-price'), 10);
      if (!(total > 0) || !(price > 0) || price >= total) return;
      var badge = document.createElement('span');
      badge.className = 'onni-sale-badge';
      // Rechnung zentral in discount.js (Code-Review A-08); der Rueckfall greift nur, wenn
      // discount.js gar nicht geladen hat.
      var P = window.ONNI_PREIS;
      badge.textContent = '−' + (P ? P.prozentRund(total, price) : Math.round((1 - price / total) * 100)) + '%';
      card.appendChild(badge);
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.onni-set-info');
    if (btn) {
      e.preventDefault();
      e.stopPropagation();
      // Trigger sitzt inline in der Preiszeile, das Modal weiter im Extras-Block der Buybox
      var dlg = btn.parentElement.querySelector('.onni-set-dialog')
        || document.querySelector('product-price .onni-set-extras .onni-set-dialog')
        || document.querySelector('.onni-set-extras .onni-set-dialog');
      if (dlg) dlg.showModal();
      return;
    }
    var close = e.target.closest('.onni-set-dialog [data-close]');
    if (close) {
      close.closest('dialog').close();
      return;
    }
    // Klick auf den Backdrop schliesst (Klickziel = <dialog> selbst, nicht der Inhalt)
    if (e.target instanceof HTMLElement && e.target.matches('dialog.onni-set-dialog')) {
      e.target.close();
    }
  });

  if (document.readyState !== 'loading') initBadges();
  else document.addEventListener('DOMContentLoaded', initBadges);
  // Nach dem Pillen-Wechsel sind die Karten neu und ohne Badge (Code-Review A-04).
  document.addEventListener('onni:collection-swapped', initBadges);
  // Beim Runterscrollen nachgeladene Karten (Infinite Scroll, Seite 2 ff.) bekamen kein
  // Badge (Paavo 01.11.2026). initBadges ist idempotent, ueberspringt Karten mit Badge.
  var nachlauf = null;
  new MutationObserver(function (muts) {
    if (nachlauf) return;
    var neu = muts.some(function (m) {
      return Array.prototype.some.call(m.addedNodes, function (n) {
        return n.nodeType === 1 && (n.matches('[data-onni-single-total]') || !!n.querySelector('[data-onni-single-total]'));
      });
    });
    if (!neu) return;
    nachlauf = setTimeout(function () { nachlauf = null; initBadges(); }, 100);
  }).observe(document.body, { childList: true, subtree: true });
})();
